import { useCallback } from "react";
import { getExpiresIn } from "../services";
import { Button, Row } from "../lib";
import { BookingItem, BookingItemProps } from "./booking-item";
import { Timer } from "./timer";
import { createStyles, sizes } from "../theme";

type Props = BookingItemProps & {
  loading?: boolean;
  onAccept: (id: number) => void;
  onDecline: (id: number) => void;
};

export function BookingItemVerified({
  booking,
  loading = false,
  onAccept,
  onDecline,
  ...rest
}: Props) {
  const handleAccept = useCallback(() => {
    onAccept?.(booking.id);
  }, [onAccept, booking.id]);

  const handleDecline = useCallback(() => {
    onDecline?.(booking.id);
  }, [onDecline, booking.id]);

  const initialCount = getExpiresIn(
    new Date(booking.requested_at),
    booking.timeout,
  );

  const timer = <Timer value={initialCount} />;

  const actions = (
    <Row.R style={$.actions}>
      <Button onPress={handleDecline} compact>
        Decline
      </Button>
      <Button em onPress={handleAccept} compact loading={loading}>
        Accept
      </Button>
    </Row.R>
  );

  return <BookingItem {...{ ...rest, booking, actions, timer }} />;
}

const $ = createStyles({
  actions: {
    gap: sizes["2"],
  },
});
